module.exports = __webpack_public_path__ + "static/media/hover_image_pulldown.2d7faf03.png";